<div echarts [options]="adaptedOptions()" [initOpts]="initOpts" [autoResize]="true" class="ogive-chart"></div>
